import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

/**
 * NotFoundPage — 404 fallback for unmatched routes.
 * Uses i18n for FR/EN/ES copies.
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background p-4 text-center">
      <p className="text-6xl font-bold text-primary" aria-hidden>
        404
      </p>
      <h1 className="text-2xl font-semibold">{t('errors.notFound.title')}</h1>
      <p className="max-w-md text-muted-foreground">
        {t('errors.notFound.description')}
      </p>
      <Button asChild>
        <Link to="/dashboard">{t('common.backToDashboard')}</Link>
      </Button>
    </main>
  );
}
